"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniMenu = void 0;
const MeasurementService_1 = require("../measurement/MeasurementService");
const UiElements_1 = require("../ui/UiElements");
const MiniMenuControls_1 = require("./components/MiniMenuControls");
class MiniMenu {
    constructor() {
        this.navigationFunctions = {
            left: () => this.setPosition(3 /* LEFT */),
            right: () => this.setPosition(4 /* RIGHT */),
            top: () => this.setPosition(5 /* TOP */),
            bottom: () => this.setPosition(6 /* BOTTOM */),
            front: () => this.setPosition(1 /* FRONT */),
            back: () => this.setPosition(2 /* BACK */),
            center: () => PubSub.publish("initial-position-goto" /* INITIAL_POSITION_GOTO */),
        };
        this.measurementFunctions = {
            distance: () => this.measurementService.measurementStart(1 /* DISTANCE */),
            height: () => this.measurementService.measurementStart(2 /* HEIGHT */),
            angle: () => this.measurementService.measurementStart(3 /* ANGLE */),
            area: () => this.measurementService.measurementStart(4 /* AREA */),
            clear: () => this.measurementService.clear()
        };
        this.exitFunction = () => this.hideMenu();
        this.measurementService = new MeasurementService_1.MeasurementService();
        this.miniMenuWrapper = this.createMiniMenuWrapper();
        this.miniMenuContent = this.createMiniMenuContent();
        this.miniMenuWrapper.addChild(this.miniMenuContent);
        this.miniMenuControls = new MiniMenuControls_1.MiniMenuControls(this.miniMenuContent.domEl);
        this.addEvents();
    }
    dispose() {
        this.removeEvents();
    }
    createMiniMenuWrapper() {
        return new UiElements_1.DivEl().setId('miniMenu').setClass('menu');
    }
    createMiniMenuContent() {
        return new UiElements_1.DivEl().setId('miniMenuContent');
    }
    addEvents() {
        Object.keys(this.miniMenuControls.buttons.navigation).forEach(key => {
            const button = this.miniMenuControls.buttons.navigation[key];
            if (this.navigationFunctions[key]) {
                button.setEvent('click', this.navigationFunctions[key]);
            }
        });
        Object.keys(this.miniMenuControls.buttons.measurement).forEach(key => {
            const button = this.miniMenuControls.buttons.measurement[key];
            if (this.measurementFunctions[key]) {
                button.setEvent('click', this.measurementFunctions[key]);
            }
        });
    }
    setPosition(positionType) {
        PubSub.publish("change-model-view-position" /* CHANGE_MODEL_VIEW_POSITION */, positionType);
    }
    hideMenu() {
        this.miniMenuWrapper.removeClass('active');
    }
    removeEvents() {
        Object.keys(this.miniMenuControls.buttons.navigation).forEach(key => {
            const button = this.miniMenuControls.buttons.navigation[key];
            if (this.navigationFunctions[key]) {
                button.removeEvent('click', this.navigationFunctions[key]);
            }
        });
        Object.keys(this.miniMenuControls.buttons.measurement).forEach(key => {
            const button = this.miniMenuControls.buttons.measurement[key];
            if (this.measurementFunctions[key]) {
                button.removeEvent('click', this.measurementFunctions[key]);
            }
        });
    }
}
exports.MiniMenu = MiniMenu;
